/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.directive('videoJs', () => ({
    restrict: 'E',
    template: '<video class="video-js vjs-default-skin"><source type="video/mp4" /></video>',
    replace: true,

    scope: {
        src: '='
    },

    link($scope, element, attributes, controller) {
        const player = videojs(element[0]);

        return $scope.$watch('src', function(new_source) {
            if (!new_source) { return; }

            player.pause();
            player.src(new_source);
            return player.play();
        });
    }
}));

intra_module.directive('showOnDev', function(is_production) {
    return function(scope, elm, attrs) {
        if (!is_production) {
            $(elm).show();
        }
    };
});

intra_module.directive('onBlur', () => (scope, elem, attrs) => elem.on('blur', () => scope.$apply(attrs.onBlur)));


intra_module.directive('onFocus', () => (scope, elem, attrs) => elem.on('focus', () => scope.$apply(attrs.onFocus)));

intra_module.directive('navbarItem', () => ({
    restrict:    'E',
    template:    '<li ng-class="{active:isSelected()}">  <a ng-href="{{href}}" ng-transclude></a></li>',
    replace:     true,
    transclude:  true,

    scope: {
        href: '@'
    },

    controller($scope, $location) {
        return $scope.isSelected = () => `#${$location.$$path}` === $scope.href;
    }
}));

intra_module.directive('msgView', () => ({
    link(scope, element, attrs) {
        const $el = $(element);
        return scope.$watch(attrs.msgView, function(value) {
            let ti;
            if (value !== 0) {
                $el.prepend('<i class="fa fa-circle-o"></i>');
                ti = null === value ? 'Aucun message lu' : value + ' messages non lus';
            } else {
                $el.prepend('<i class="fa fa-check"></i>');
                ti = 'Tous les messages sont lus';
            }
            return element.tooltip({
                title: ti,
                placement: 'top'
            });
        });
    }
}));
